<app-stepper-form
  header="Change of Company Status"
  subheader="Form 484B3"
  formIcon="ic-change-to-company-status-20"
  [showSteps]="false"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [isLoading]="isLoading"
  [form]="stepperForm"
>
  <div class="step-content" [formGroup]="stepperForm">
    <app-stepper-form-description
      formKey="484 B3"
      [hidden]="currentStep !== StepsEnum.FormDescription"
    />

    <section
      class="step-section"
      [hidden]="currentStep !== StepsEnum.CompanyStatusChange"
      [formGroupName]="StepsEnum.CompanyStatusChange"
    >
      <h1 class="h1-heading">{{ steps[currentStepIndex].label }}</h1>

      <div class="form-group">
        <app-date-picker
          label="Date of Change"
          formControlName="changeDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [customErrors]="customDatepickerErrors"
        />
      </div>

      @if (lateFeeMessage) {
        <app-disclaimer
          color="red"
          icon="ic-info-circle-20"
        >
          {{ lateFeeMessage }}
        </app-disclaimer>
      }

      <div class="form-group">
        <app-select
          label="The Change is"
          formControlName="changeIs"
          [options]="availableChangeTypesOptions"
          [valuePrimitive]="true"
        />
      </div>

      <div class="form-group" [hidden]="isSpecialPurposeHidden()">
        <app-select
          label="What type of special purpose company?"
          formControlName="newCompanySubtype"
          [options]="statusOptions"
          [valuePrimitive]="true"
        />
      </div>
    </section>
  </div>
</app-stepper-form>
